import { Ref } from 'vue';
import { httpClient } from '@/core/axios/http-client';
import { AppCoreEnums } from '../../core/shared/enums';
import { DeletePayload, ICoreState, RestorePayload, IToastMessage } from './models';

const useTagsStoreActions = (state: Ref<ICoreState>) => {
  const setIsCollapsibleTableContainerLeftPanelCollapsed = (isCollapsed: boolean) => {
    state.value.collapsibleTableContainerData.isLeftPanelCollapsed = isCollapsed;
    if (!isCollapsed) {
      state.value.collapsibleTableContainerData.detailsTitle = '';
    }
  };

  const setIsCollapsibleTableInnerContainerLeftPanelCollapsed = (isCollapsed: boolean) => {
    state.value.collapsibleTableInnerContainerData.isLeftPanelCollapsed = isCollapsed;
    if (!isCollapsed) state.value.collapsibleTableInnerContainerData.detailsTitle = '';
  };

  const setIsCollapsibleTableContainerLeftPanelInMiniMode = (payload: boolean, explicitRequestedByUser = false) => {
    if (explicitRequestedByUser) {
      state.value.collapsibleTableContainerData.isLeftPanelInMiniModeExplicitRequestedByUser = explicitRequestedByUser;
    }
    state.value.collapsibleTableContainerData.isLeftPanelInMiniMode = payload;
  };

  const setIsCollapsibleTableInnerContainerLeftPanelInMiniMode = (payload: boolean, explicitRequestedByUser = false) => {
    if (explicitRequestedByUser) {
      state.value.collapsibleTableInnerContainerData.isLeftPanelInMiniModeExplicitRequestedByUser = explicitRequestedByUser;
    }

    state.value.collapsibleTableInnerContainerData.isLeftPanelInMiniMode = payload;
  };

  const toggleMainDrawerMiniMode = () => {
    state.value.useMiniForMainDrawer = !state.value.useMiniForMainDrawer;
  };

  const setMainDrawerMiniMode = (value: boolean) => {
    state.value.useMiniForMainDrawer = value;
  };

  const setUseMiniModeForMainDrawer = (useMiniMode: boolean) => {
    state.value.useMiniForMainDrawer = useMiniMode;
  };

  const refreshTableBasedContainer = (containerType: AppCoreEnums.ContainerType) => {
    switch (containerType) {
      case AppCoreEnums.ContainerType.CollapsibleTableContainer:
        state.value.collapsibleTableContainerData.refreshRequestCount++;
        break;

      case AppCoreEnums.ContainerType.TableContainer:
        state.value.tableContainerData.refreshRequestCount++;
        break;

      case AppCoreEnums.ContainerType.TableInnerContainer:
        state.value.tableInnerContainerData.refreshRequestCount++;
        break;

      case AppCoreEnums.ContainerType.ListContainer:
        state.value.tableContainerData.refreshRequestCount++;
        break;
    }
  };

  const resetContainerSelectedRows = (containerType: AppCoreEnums.ContainerType) => {
    switch (containerType) {
      case AppCoreEnums.ContainerType.CollapsibleTableContainer:
        state.value.collapsibleTableContainerData.selectedRows.length = 0;
        break;

      case AppCoreEnums.ContainerType.TableContainer:
        state.value.tableContainerData.selectedRows.length = 0;
        break;

      case AppCoreEnums.ContainerType.TableInnerContainer:
        state.value.tableInnerContainerData.selectedRows.length = 0;
        break;
    }
  };

  const setContainerSearchBy = (containerType: AppCoreEnums.ContainerType, payload: string) => {
    switch (containerType) {
      case AppCoreEnums.ContainerType.CollapsibleTableContainer:
        state.value.collapsibleTableContainerData.searchBy = payload;
        break;

      case AppCoreEnums.ContainerType.TableContainer:
        state.value.tableContainerData.searchBy = payload;
        break;

      case AppCoreEnums.ContainerType.TableInnerContainer:
        state.value.tableInnerContainerData.searchBy = payload;
        break;

      case AppCoreEnums.ContainerType.DrawerContainer:
        state.value.drawerContainerData.searchBy = payload;
        break;

      case AppCoreEnums.ContainerType.LogsTableContainer:
        state.value.logsTableContainerSearchBy = payload;
        break;

      case AppCoreEnums.ContainerType.ListContainer:
        state.value.listContainerData.searchBy = payload;
        break;
    }
  };

  const setContainerFiltersHeight = (containerType: AppCoreEnums.ContainerType, height: number) => {
    switch (containerType) {
      case AppCoreEnums.ContainerType.CollapsibleTableContainer:
        state.value.sizes.collapsibleTableContainerFiltersHeight = height;
        break;

      case AppCoreEnums.ContainerType.TableContainer:
        state.value.sizes.tableContainerFiltersHeight = height;
        break;

      case AppCoreEnums.ContainerType.TableInnerContainer:
        state.value.sizes.tableInnerContainerFiltersHeight = height;
        break;
    }
  };

  const deleteEntities = (entityName: string, ids: number[]) => {
    const payload = new DeletePayload();
    payload.ids = ids;
    payload.entityName = entityName;

    return httpClient.post<void, number>('common/delete', payload).then((response) => {
      return response;
    });
  };

  const restoreEntities = (entityName: string, ids: number[]) => {
    const payload = new RestorePayload();
    payload.ids = ids;
    payload.entityName = entityName;

    return httpClient.post<void, number>('common/restore', payload).then((response) => {
      return response;
    });
  };

  const setToastMessage = (message: IToastMessage | undefined) => {
    state.value.toastMessage = message;
  };

  return {
    deleteEntities,
    restoreEntities,
    setContainerSearchBy,
    setMainDrawerMiniMode,
    toggleMainDrawerMiniMode,
    setContainerFiltersHeight,
    refreshTableBasedContainer,
    resetContainerSelectedRows,
    setUseMiniModeForMainDrawer,
    setIsCollapsibleTableContainerLeftPanelCollapsed,
    setIsCollapsibleTableContainerLeftPanelInMiniMode,
    setIsCollapsibleTableInnerContainerLeftPanelCollapsed,
    setIsCollapsibleTableInnerContainerLeftPanelInMiniMode,
    setToastMessage,
  };
};

export default useTagsStoreActions;
